import { AiseaApiFactory } from "@/api/aisea/apiFactory";
import { FormatUtil, DateUtil } from "@/utils";
const reportApi = AiseaApiFactory.get("report");

export default {
  async fetchReports({ commit }, payload) {
    let res = await reportApi.search(payload);
    let reports = [];

    // IDフォーマット
    res.data.reports.forEach(r => {
      let report_at = DateUtil.toYMD(r.created_at, "YYYYMMDD")
      let vesselId = FormatUtil.zeroPadding(Number(r.vessel.id), 5);
      let index = FormatUtil.zeroPadding(r.index_number, 3);
      r["report_id"] = `${report_at}-${vesselId}-${index}`;
      reports.push(r);
    });

    commit("SET_REPORTS", reports);
    commit("SET_PAGING", res.data.pageable);
    return res.data;
  },

  async resetReportListState({ commit }) {
    let defaultState = {
      reports: [],
      pageable: null,
      countryCodes: []
    };
    commit("RESET_STATE", defaultState);
  }
};
